<div class="d-flex align-items-center my-1 px-1">
  @if (props.label) {
    <div class="text w-50" matTooltip="{{ props.tooltip ? (props.tooltip | apmTranslate) : undefined }}">
      {{ props.label | apmTranslate }}
      <br />
      @if (hasDatasheetMoreDetailsPermission && props.label) {
        <span>{{ field.key }} {{ props.name }}</span>
      }
    </div>
  }

  @let iconResourceId = props.iconResourceId;
  <div
    class="apm-field-wrapper"
    [ngClass]="{ 'w-50': props.label, 'w-100': !props.label }"
    [class.with-image-icon]="!!iconResourceId"
  >
    @if (iconResourceId) {
      <img class="apm-field-icon apm-prefix-field-icon" [apmResourceImage]="iconResourceId" />
    }
    <apm-select
      class="w-100 overflow-hidden"
      [items]="$any(props.options)"
      [clearable]="false"
      [searchable]="true"
      [formControl]="formControl"
      [groupBy]="props.groupByProperty"
      [virtualScroll]="true"
      [searchFn]="searchFn"
      bindLabel="label"
      bindValue="value"
    >
      <div class="text-truncate" *apmSelectLabelTpl="let item; let clear = clear">
        @if (hasDatasheetMoreDetailsPermission) {
          <span>{{ item.value }} - &nbsp;</span>
        }
        @if (item.translateLabel) {
          {{ item.label | apmTranslate }}
        } @else {
          {{ item.label }}
        }
      </div>
      <div class="text-truncate" *apmSelectOptionlTpl="let item; let clear = clear">
        @if (hasDatasheetMoreDetailsPermission) {
          <span>{{ item.value }} - &nbsp;</span>
        }
        @if (item.translateLabel) {
          {{ item.label | apmTranslate }}
        } @else {
          {{ item.label }}
        }
      </div>
    </apm-select>
  </div>
</div>
